import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BlobFileDownloadRequestModel } from '../../models/blob-file-sas-url.model';
import { DownloadCSV } from '../../models/download-csv.model';
import { SettingsService } from '../common/settings.service';

@Injectable({
  providedIn: 'root'
})
export class DownloadReportService {
  constructor(
    private http: HttpClient,
    public settings: SettingsService
  ) {}

  getDownloadCSVFilesList(): Observable<DownloadCSV[]> {
    return this.http.get<DownloadCSV[]>(
      this.settings.baseUrl +
        'api/M365acceleratorNominations/GetDownloadCSVList'
    );
  }

  getDownloadCSVFile(
    downloadModal: BlobFileDownloadRequestModel
  ): Observable<string> {
    return this.http.post<string>(
      this.settings.baseUrl + 'api/M365acceleratorNominations/DownloadCSVFile',
      downloadModal
    );
  }
}
